import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Ahora entro al aula con todo listo.',
    author: 'Mariana López',
    role: 'Docente primaria'
  }, {
    quote: 'Me ahorró horas de planificación.',
    author: 'Laura Fernández',
    role: '3° grado'
  }, {
    quote: 'Mis alumnos participan mucho más.',
    author: 'Carolina Pérez',
    role: 'Ciencias Naturales'
  }, {
    quote: 'Es el recurso más completo que usé.',
    author: 'Silvia Gómez',
    role: 'Directora primaria'
  }];
  return <section className="bg-gray-50 py-16 px-4" data-id="element-207">
      <div className="max-w-6xl mx-auto" data-id="element-208">
        <h2 className="text-4xl font-black text-center text-gray-900 mb-12 font-['Oswald'] uppercase" data-id="element-209">
          Lo que dicen otras docentes
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-210">
          {testimonials.map((t, idx) => <div key={idx} className="bg-white p-6 rounded-lg shadow-md border-b-4 border-blue-500" data-id="element-211">
              <div className="flex gap-1 text-yellow-400 mb-4" data-id="element-212">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-213" />)}
              </div>
              <p className="text-lg font-medium text-gray-800 mb-6 italic" data-id="element-214">
                "{t.quote}"
              </p>
              <div data-id="element-215">
                <p className="font-bold text-gray-900" data-id="element-216">{t.author}</p>
                <p className="text-sm text-gray-500" data-id="element-217">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}